export class ImageDto {
  public extension?: string;
  public name?: string;
  public relativePath?: string;
  public imageData?: string;
}
